import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/auth'
import { isSuperAdmin } from './roles'

// ────────────────────────────────────────────────────────────────────────────────
// JUSTIFICATION:
// 
// Navigation Guard for SuperAdmin-Only Routes
// - Rationale: Protects system-wide administrative features from unauthorized access
// - Pattern: Similar to RequireTenantAdmin but stricter (SuperAdmin role only)
// - Security: Backend MUST enforce same check; this is UI-level protection only
// - UX: Redirects to home instead of showing unauthorized message
// ────────────────────────────────────────────────────────────────────────────────

export default function RequireSuperAdmin({ children }: { children: JSX.Element }) {
  const user = useAuthStore((state) => state.user)
  
  // Redirect non-SuperAdmin users to home page
  if (!isSuperAdmin(user?.role)) {
    return <Navigate to="/" replace />
  }

  return children
}
